import { formatProfileUrl } from '../Users'
import { FirebaseUser, User } from '../Users/types'
import { getFirAuth } from './firebaseConnect'

export type FavType = 'topics' | 'favPlayers' | 'favTeam'

export const NO_USER: User = {
  isLoggedIn: false,
  isAnonymous: true,
  userId: null,
  email: null,
  favPlayers: [],
  topics: [],
}

/**
 * Get currently logged user data from firebase
 */
export const getCurrentUser = async (): Promise<FirebaseUser> => {
  const usr = (await getFirAuth())?.currentUser
  if (usr && usr.uid) {
    // logged in user
    let firUser: FirebaseUser = {
      isLoggedIn: usr.isAnonymous ? false : true,
      isAnonymous: usr.isAnonymous,
      userId: usr.uid,
    }
    if (usr?.displayName) {
      firUser['firstName'] = usr.displayName.split(' ')[0]
      firUser['lastName'] = usr.displayName.split(' ')[1]
    }
    if (usr?.email) {
      firUser['email'] = usr.email
    }
    if (usr?.phoneNumber) {
      firUser['phone'] = usr.phoneNumber
    }
    if (usr?.photoURL) {
      firUser['profileUrl'] = usr.photoURL
    }

    return firUser
  }
  // not logged in
  return NO_USER
}

/**
 * Get currently logged user data
 */
export const setUpdatedUserData = async (userRes: any): Promise<User> => {
  const usr = (await getFirAuth())?.currentUser
  if (usr && usr.uid) {
    // logged in user
    let userObj: User = {
      ...userRes,
      isLoggedIn: usr.isAnonymous ? false : true,
      profileUrl: userRes?.profileUrl ? formatProfileUrl(userRes.profileUrl) : ''
    }
    return userObj
  }
  // not logged in
  return NO_USER
}
